import React from 'react';
import { Paper } from 'material-ui';
import R from 'ramda';
import injectSheet from 'react-jss';
import { AllocationDiff, ExtrasDiff, BlackoutsDiff, SeasonRatesDiff, PickupDropoffDiff, OffersDiff, ProductPolicyDiff } from './ratePackage-elements';
import { UpdateSummary } from './section-updateSummary';

const styles = {
  typeContainer: {
    marginTop: '32px',
  },
  subHeader: {
    fontSize: '20px',
    lineHeight: '24px',
    fontWeight: 400,
    marginTop: '4px',
    paddingBottom: '12px',
    width: '90%',
    borderBottom: '1px solid #e6e9ec',
  },
  singleDiffContainer: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  lhsContainer: {
    width: '45%',
    // padding: '16px 4px',
  },
  rhsContainer: {
    marginLeft: '5%',
    width: '45%',
    // padding: '16px 4px',
  },
  subLabelsClass: {
    margin: '16px 0 0 20px',
  },
};

const propTypes = {
  diffBlock: React.PropTypes.object,
  classes: React.PropTypes.object,
  label: React.PropTypes.string,
  type: React.PropTypes.string,
  updateSummary: React.PropTypes.array,
  ratePackageId: React.PropTypes.string,
};
class RatePackageDiffing extends React.Component {
  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== React.PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }
  render() {
    const { diffBlock, classes, label, type, updateSummary, ratePackageId } = this.props;
    const {
      singleDiffContainer,
      lhsContainer,
      rhsContainer,
      typeContainer,
      subHeader,
    } = classes;
    const policies = ['cancellation', 'child', 'infant', 'family', 'freeOfCharge', 'group'];
    const ComponentBlock = R.call(R.cond([
      [() => type === 'allocation', R.always(AllocationDiff)],
      [() => type === 'extras', R.always(ExtrasDiff)],
      [() => type === 'blackouts', R.always(BlackoutsDiff)],
      [() => type === 'pickup' || type === 'dropoff', R.always(PickupDropoffDiff)],
      [() => type === 'offers', R.always(OffersDiff)],
      [() => policies.indexOf(type) > -1, R.always(ProductPolicyDiff)],
      [() => diffBlock.season || diffBlock.rateSets, R.always(SeasonRatesDiff)],
      [R.T, R.always(null)]
    ]));
    return (
      <section id={`${ratePackageId}${type}`} className={typeContainer}>
        <div className={subHeader}>{label}</div>
        {
          // Boolean(updateSummary && updateSummary.length) && (
          //   <UpdateSummary
          //     updateSummary={updateSummary}
          //   />
          // )
        }
        {
          Boolean(ComponentBlock) && (
            <div className={singleDiffContainer}>
              <div className={lhsContainer}>
                <ComponentBlock isLeft {...diffBlock} type={type} />
              </div>
              <div className={rhsContainer}>
                <ComponentBlock isLeft={false} {...diffBlock} type={type} />
              </div>
            </div>
          )
        }
      </section>
    )
  }
}

export default injectSheet(styles)(RatePackageDiffing);





// WEBPACK FOOTER //
// ./src/app/components/contracting-reports/diff-report/diffing/ratePackage-content.jsx